<template>
   <div class="create-lesson width margin-left-3Perc margin-top-2Point5Perc container-fluid lesson-box-border" @keydown.esc="performCloseOperation"> 
        <div class="overflow-hidden">
            <div class="row padding-Top-2Perc vertical-align text-align-left">
              <div class="col-md-12 col-lg-12">
                Showing results for:
              </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 font-color-blue font-size-21px text-align-left font-weight-bold">{{this.$store.state.selectedCourseObjFromFilter.CourseTitle}} {{this.$store.state.selectedCourseObjFromFilter.SubTitle === null || this.$store.state.selectedCourseObjFromFilter.SubTitle === '' || this.$store.state.selectedCourseObjFromFilter.SubTitle === undefined ? '' : '[' + this.$store.state.selectedCourseObjFromFilter.SubTitle + ']'}}
                </div>  
            </div>    
            <hr/>
            <div class="row padding-Top-1Perc">
              <div class="col-xs-3 col-sm-2 col-md-1 col-lg-1 font-size-21px text-align-left">
                  Lesson
              </div>
              <div class="col-xs-9 col-sm-5 col-md-4 col-lg-4">
                  <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <div class="form-group">
                              <div class="icon-addon addon-lg">
                              <input type="text" class="form-control background-gray border-rounded" autocomplete="off" id="email" v-model="enteredLessonNameInSearch"/>
                              <label class="glyphicon glyphicon-search"></label>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-xs-12 col-sm-5 col-md-6 col-lg-6 text-align-left">
                <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 padding-left-0px">
                  <button type="button" class="btn gray-border custom-btn white-BG" v-on:click="updateHideCreateLessonOverlayFlag($event,false)">+ Create New</button>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 padding-left-0px">
                  <button type="button" class="btn gray-border custom-btn white-BG" v-on:click="openImportLessonOverlay">Import Lesson</button>
                </div>
                <div class="col-md-3 col-lg-3 padding-left-0px text-align-left">
                  <button type="button" class="btn gray-border custom-btn white-BG padding-bottom-4px padding-top-7px" @click="expandAllLessons">
                    <span class="glyphicon glyphicon-resize-full font-size-16px"></span> Expand All
                  </button>
                </div>
                <div class="col-md-3 col-lg-3 padding-left-0px text-align-left">
                  <button type="button" class="btn gray-border custom-btn white-BG padding-bottom-4px padding-top-7px text-align-left" @click="collapseAllLessons">
                    <span class="glyphicon glyphicon-resize-small font-size-16px"></span> Collapse All
                  </button>
                </div>
              </div>
              <!-- <div class="col-md-2 col-lg-2">
                  <button type="button" class="btn gray-border custom-btn white-BG" v-on:click="openImportLessonOverlay">Import Lesson</button>
              </div> -->
              <div class="col-md-1 col-lg-1"></div>
            </div>
             <div class="row overflow-y-hidden center-align-div">
                <div class="col-md-12 col-lg-12 overflow-y-hidden">
                    <!-- <lesson-list v-for="lessObj in tableFilter" :key="lessObj.Index" v-bind:LessonObj="lessObj"></lesson-list> -->
                    <div class="drag">
                      <draggable :tableFilter="tableFilter" v-model="tableFilter" @start="dragMove($event)">
                        <transition-group>
                          <lesson-list v-for="lessObj in tableFilter" :key="lessObj.ModuleId" :isComingFrom="isComingFrom" v-bind:LessonObj="lessObj" v-if="!lessObj.IsBonusContent"></lesson-list>
                        </transition-group>
                      </draggable>
                  </div>
                </div>     
            </div>    
        </div>
        <!-- Create Lesson Overlay -->
        <div id="myNav" class="overlay overlay-overall-width-0Perc" v-bind:class="{'overlay-overall-width-100Perc': !hideCreateLessonOverlay}">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc cursor-pointer" v-on:click="updateHideCreateLessonOverlayFlag($event,true)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  <!-- Index -->
                  Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <!-- <input type="text" class="form-control" v-model="lessonIndexValue" :disabled="isBonusContentLessonValue"> -->
                            <input type="text" class="form-control" v-model="lessonTitleValue" :maxlength="title_maxLength">
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  <span v-if="parseInt(moduleObj.ModuleType) === parseInt(constants.ModuleType.Normal) && getCurrentCourseObj.Type !== constants.CourseType.RecommendationAssessment">Is Optional</span>
                </div>  
                <div class="col-md-3 col-lg-3 text-align-left vertical-align">
                  <label class="switch" v-if="parseInt(moduleObj.ModuleType) === parseInt(constants.ModuleType.Normal) && getCurrentCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                    <input type="checkbox" v-model="isOptionalLessonValue">
                    <span class="slider round"></span>
                  </label>
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="parseInt(moduleObj.ModuleType) === parseInt(constants.ModuleType.Normal) && getCurrentCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Release Date
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <date-picker v-model="date" :config="config"></date-picker>
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px" v-if="!isBonusContentLessonValue">
                  Is Unlocked
                </div>  
                <div class="col-md-3 col-lg-3 text-align-left vertical-align">
                  <label class="switch" v-if="!isBonusContentLessonValue">
                    <input type="checkbox" v-model="lessonUnlockedValue">
                    <span class="slider round"></span>
                  </label>
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="parseInt(moduleObj.ModuleType) === parseInt(constants.ModuleType.Normal) && getCurrentCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Duration
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                          <input type="text" class="form-control" v-model="lessonDurationValue" disabled>
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Is Bonus Content
                </div>  
                <div class="col-md-3 col-lg-3 text-align-left vertical-align">
                  <label class="switch">
                    <input type="checkbox" v-model="isBonusContentLessonValue">
                    <span class="slider round"></span>
                  </label>
                </div>  
              </div>
              <!-- <div class="row vertical-align margin-bottom-2Perc" v-if="this.$store.state.selectedCourseObjFromFilter.LessonNumbering == constants.LessonNumberingType.Custom"> -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="this.$store.state.selectedCourseObjFromFilter.LessonNumbering == 1 && parseInt(moduleObj.ModuleType) === parseInt(constants.ModuleType.Normal) && getCurrentCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Lesson Number Text
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="lessonNumberTextValue" maxlength="24">
                    </div>
                  </div>
                </div> 
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="!isBonusContentLessonValue && parseInt(moduleObj.ModuleType) === parseInt(constants.ModuleType.Normal) && getCurrentCourseObj.Type !== constants.CourseType.RecommendationAssessment">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Topic Name
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="lessonTopicObjValue">
                        <option value=-1>None</option>
                        <option v-for="topicObj in getMasterTopicList" :key="topicObj.MasterTopicId" :value="topicObj.MasterTopicId">{{topicObj.Title}}</option>
                      </select>
                    </div>
                  </div>
                </div> 
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Module Type
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="moduleTypeValue">
                        <option :value=constants.ModuleType.Normal>Normal</option>
                        <option :value=constants.ModuleType.Personalization>Personalization</option>
                        <option :value=constants.ModuleType.Assessment v-if="getCurrentCourseObj.Type === constants.CourseType.RecommendationAssessment">Assessment</option>
                      </select>
                    </div>
                  </div>
                </div> 
              </div>
              <!-- <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Is Published
                </div>  
                <div class="col-md-3 col-lg-3 text-align-left vertical-align">
                  <label class="switch">
                    <input type="checkbox" v-model="isPublishedLessonValue">
                    <span class="slider round"></span>
                  </label>
                </div>  
              </div> -->
              <div class="row margin-bottom-2Perc">
                <div class="col-md-4 col-lg-4">
                </div>  
                <div class="col-md-4 col-lg-4">
                   <!-- ToDo: Track this -->
                  <div class="col-lg-3"></div>
                  <div class="col-lg-8">
                    <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createLesson">{{btnTxt}}</button>
                  </div>
                  <div class="col-lg-1"></div>
                </div>  
                <div class="col-md-4 col-lg-4">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <import-lesson-overlay v-if="showImportLessonOverlay" @closeOverlay="updateShowImportLessonOverlay" :isComingFrom="isComingFrom"></import-lesson-overlay>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="swipLesson"></confirmation-alert>
      <add-bonus-video-overlay v-if="showAddBonusVideoElementOverlay" v-bind:bonusModuleServerRespObj="bonusModuleRespObj" @closeAddBonusContent="upateAddBonusContentOverlayFlag"></add-bonus-video-overlay>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    </div> 
</template>
<script>
import Loader from '@/components/dashboard/Loader'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { constants } from '@/utils/constants'
import { moduleService } from '@/server-util/module-service'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import LessonList from '@/components/LessonList'
import ImportLessonOverlay from '@/components/ImportLessonOverlay'
import draggable from 'vuedraggable'
import LessonListCreateElementOption from '@/components/LessonListCreateElementOption'
import AlertBox from '@/components/AlertOverlay'
import AddBonusVideoOverlay from '@/components/AddBonusVideoOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { masterTopicService } from '@/server-util/master-topic-service'
//  import qs from 'qs'
export default {
  props: ['isComingFrom'],
  name: 'create-lesson',
  created () {
    // this.getTopicList()
    this.setCourseMasterId()
    this.setReleaseDate()
  },
  data: function () {
    var currEstTS = dmAdminUtils.getCurrentEst()
    return {
      constants: constants,
      hideCreateLessonOverlay: true,
      moduleObj: {
        Index: null,
        Title: '',
        ReleaseDate: '',
        Duration: '',
        IsUnlocked: false,
        IsBonusContent: false,
        IsOptional: false,
        IsPublished: false,
        CourseMasterId: '',
        LessonNumberText: '',
        ModuleType: constants.ModuleType.Normal,
        MasterTopic: {
          MasterTopicId: -1
        }
      },
      showAlertDialog: false,
      errorMsg: '',
      enteredLessonNameInSearch: null,
      btnTxt: 'Create Lesson',
      showSpinner: false,
      showAddBonusVideoElementOverlay: false,
      bonusModuleRespObj: null,
      objArr: null,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      reIndexedObj: {
        CourseMasterId: '',
        LessonList: []
      },
      date: currEstTS,
      config: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        defaultDate: currEstTS,
        useCurrent: false,
        sideBySide: true
      },
      showImportLessonOverlay: false,
      title_maxLength: constants.Lesson_Title_Max_Length
    }
  },
  components: {
    'lesson-list': LessonList,
    'lesson-list-create-element-option': LessonListCreateElementOption,
    'alert-box': AlertBox,
    draggable,
    'add-bonus-video-overlay': AddBonusVideoOverlay,
    'confirmation-alert': ConfirmationOverlay,
    'date-picker': datePicker,
    'loader': Loader,
    'import-lesson-overlay': ImportLessonOverlay
  },
  methods: {
    getRandomGuidString: function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = Math.random() * 16 | 0
        var v = (c === 'x') ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    expandAllLessons: function () {
      this.$store.state.expandAllLessons = 'true_' + this.getRandomGuidString()
    },
    collapseAllLessons: function () {
      this.$store.state.expandAllLessons = 'false_' + this.getRandomGuidString()
    },
    getTopicList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather master topic list is already present or not?
        if (storeObj.state.masterTopicList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        masterTopicService
          .getAllMasterTopicList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.masterTopicList = responseObj.data
            } else {
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING TOPIC LIST'
        )
      }
    },
    updateShowImportLessonOverlay (value) {
      // AK: Used to close the Import Lesson Overlay
      this.showImportLessonOverlay = false
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = false
      // AK: If user imported lesson then refresh Lesson list again
      if (value.isImportedLesson) {
        this.getLessons()
      }
    },
    openImportLessonOverlay: function () {
      // AK: Open Import Lesson overlay
      this.showImportLessonOverlay = true
      // AK: disable background scrolling
      this.$store.state.isOverlayVisible = true
    },
    dragMove (evt) {
      if (evt.item !== undefined && evt.item !== null) {
        if (evt.item.attributes.isbonus) {
          this.showAlertDialog = true
          this.errorMsg = 'Bonus lessons are not movable.'
          // return
        }
      }
      // console.log('EVENT OBJ -> ', evt)
      // console.log('EVENT OBJ -> ', evt.item.attributes)
    },

    performCloseOperation: function () {},
    swipLesson (value) {
      // AK: close confirmation box
      this.showConfirmationBox = false
      if (value) {
        // AK: If post String matched to Re-order operation then perform swip operation
        if (this.postString === 'selected lesson?') {
          this.reIndexedObj.LessonList = []
          var selectedCourseObj = this.$store.state.selectedCourseObjFromFilter

          this.reIndexedObj.CourseMasterId = selectedCourseObj.CourseMasterId
          var minModuleIndex = selectedCourseObj.MinModuleIndex

          for (var i = 0; i < this.objArr.length; i++) {
            // AK: create Object initially
            var moduleObj = {
              ModuleId: this.objArr[i].ModuleId,
              OldIndex: 0,
              NewIndex: 0
            }
            // AK: If module is Bonus then pass values as it is
            if (this.objArr[i].IsBonusContent) {
              moduleObj.OldIndex = parseInt(this.objArr[i].Index)
              moduleObj.NewIndex = parseInt(this.objArr[i].Index)
            } else {
              // AK: For very first module object, use minIndex and later on increase it by one
              if (i !== 0) {
                minModuleIndex += 1
              }
              moduleObj.OldIndex = parseInt(this.objArr[i].Index)
              moduleObj.NewIndex = parseInt(minModuleIndex)
            }
            this.reIndexedObj.LessonList.push(moduleObj)
          }
          // AK: Issue server call
          this.reIndexLessons()
        } else {
          // AK: Perform Add bonus video operations
          // AK: Hide Create Lesson Overlay
          this.hideCreateLessonOverlay = true
          // AK: Disable background scroll
          this.$store.state.isOverlayVisible = true
          // AK: Show add bonus content Overlay
          this.showAddBonusVideoElementOverlay = true
        }
      }
    },
    reIndexLessons: function () {
      // console.log('Object To pass >>>' + JSON.stringify(this.reIndexedObj))
      var _this = this
      var storeObj = this.$store
      if (
        this.reIndexedObj.CourseMasterId !== undefined ||
        this.reIndexedObj.CourseMasterId !== ''
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        moduleService
          .reIndexModule(storeObj.state.access_token, _this.reIndexedObj)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Assign newly recieved list
              storeObj.state.selectedMasterClassModuleList = responseObj.data
              // console.log('Re-indexed List >>> ' + JSON.stringify(storeObj.state.selectedMasterClassModuleList))
              // AK: Reset Obj
              this.objArr = null
              this.$store.state.isLessonSwipped = false
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected COURSEMASTERID is NULL hence declined RE-INDEXING LESSON OPERATION'
        )
      }
    },
    upateAddBonusContentOverlayFlag (value) {
      // AK: Used to hide Add bonus content overlay
      this.$store.state.isOverlayVisible = value
      this.showAddBonusVideoElementOverlay = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of swipe confirmation overlay
      this.showConfirmationBox = value
      // AK: Reset Obj
      this.objArr = null
      this.$store.state.isLessonSwipped = false
      // AK: Hide Create Lesson overlay if user pressed cancel of Add Videos in Bonus module
      if (this.prefixString === 'Do you want to add video in the bonus content ') {
        this.hideCreateLessonOverlay = true
        // AK: If user closed overlay then reset object
        if (this.hideCreateLessonOverlay) {
          this.moduleObj.Index = null
          this.moduleObj.Title = ''
          this.moduleObj.LessonNumberText = ''
          this.moduleObj.ReleaseDate = this.date
          this.moduleObj.Duration = ''
          this.btnTxt = 'Create Lesson'
          this.moduleObj.IsUnlocked = false
          this.moduleObj.IsBonusContent = false
          this.moduleObj.IsOptional = false
          this.moduleObj.IsPublished = false
          this.moduleObj.ModuleType = parseInt(constants.ModuleType.Normal)
          this.config.useCurrent = true
          if (this.moduleObj.MasterTopic !== undefined && this.moduleObj.MasterTopic !== null && this.moduleObj.MasterTopic !== '' && this.moduleObj.MasterTopic !== 'null') {
            this.moduleObj.MasterTopic.MasterTopicId = -1
          }
          this.date = dmAdminUtils.getCurrentEst()
        }
      }
    },
    updateHideCreateLessonOverlayFlag: function (event, flagToUpdate) {
      this.$store.state.isOverlayVisible = !flagToUpdate
      this.hideCreateLessonOverlay = flagToUpdate
      // AK: If user closed overlay then reset object
      if (flagToUpdate) {
        this.moduleObj.Index = null
        this.moduleObj.Title = ''
        this.moduleObj.LessonNumberText = ''
        this.moduleObj.ReleaseDate = this.date
        if (this.moduleObj.MasterTopic !== undefined && this.moduleObj.MasterTopic !== null && this.moduleObj.MasterTopic !== '' && this.moduleObj.MasterTopic !== 'null') {
          this.moduleObj.MasterTopic.MasterTopicId = -1
        }
        this.moduleObj.Duration = ''
        this.btnTxt = 'Create Lesson'
        this.moduleObj.IsUnlocked = false
        this.moduleObj.IsBonusContent = false
        this.moduleObj.IsOptional = false
        this.moduleObj.IsPublished = false
        this.moduleObj.ModuleType = parseInt(constants.ModuleType.Normal)
        this.config.useCurrent = true
        this.date = dmAdminUtils.getCurrentEst()
      }
    },
    createLesson: function (event) {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var _this = this
        _this.setCourseMasterId()
        var storeObj = this.$store
        if (
          this.moduleObj.CourseMasterId !== undefined &&
          this.moduleObj.CourseMasterId !== ''
        ) {
          // AK: Hide Create Lesson Overlay after getting create Request
          // this.hideCreateLessonOverlay = true
          // AK: Enable Scrolling
          this.$store.state.isOverlayVisible = false
          // AK: Start showing spinner (course file)
          // _this.$emit('showSpinner', true)
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
          // AK: Set selected Date before post
          _this.moduleObj.ReleaseDate = this.date
          // AK: Assign again CourseMasterId before creating module
          if (this.moduleObj.ModuleType === constants.ModuleType.Personalization || this.moduleObj.ModuleType === constants.ModuleType.Assessment) {
            this.moduleObj.IsUnlocked = true
            this.moduleObj.IsBonusContent = false
            this.moduleObj.IsOptional = false
            this.moduleObj.MasterTopicId = null
            this.moduleObj.LessonNumberText = null
          }
          if (_this.moduleObj.MasterTopic === null || _this.moduleObj.MasterTopic.MasterTopicId === -1 || this.isBonusContentLessonValue) {
            _this.moduleObj.MasterTopic = null
          }
          // console.log(JSON.stringify(this.moduleObj))
          // console.log('Create Lesson Before Post >>> ' + JSON.stringify(_this.moduleObj))
          moduleService
            .createModule(storeObj.state.access_token, _this.moduleObj)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Lesson List
                _this.getLessons()
                // AK: Reset Obj before assign
                _this.bonusModuleRespObj = null
                if (_this.moduleObj.IsBonusContent) {
                  // AK: If created module is bonus then store it in another varible to pass
                  // console.log(JSON.stringify(responseObj.data))
                  _this.bonusModuleRespObj = responseObj.data
                }
              } else {
                // AK: Hide Spinner
                // _this.$emit('showSpinner', false)
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // _this.$emit('showSpinner', false)
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected COURSEMASTERID Object is NULL hence declined CREATE LESSON OPERATION'
          )
        }
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.moduleObj.Title.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (parseInt(this.moduleObj.ModuleType) === parseInt(constants.ModuleType.Normal) && this.getCurrentCourseObj.Type !== constants.CourseType.RecommendationAssessment) {
        if (this.date === null) {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a release date.'
          return false
        } if (this.moduleObj.LessonNumberText.trim().length === 0 && this.$store.state.selectedCourseObjFromFilter.LessonNumbering === 1) {
          this.showAlertDialog = true
          this.errorMsg = 'Lesson number text can\'t be empty.'
          return false
        }
      }
      return true
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getLessons: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.selectedCourseObjFromFilter.CourseMasterId !== undefined
      ) {
        moduleService
          .listModules(
            storeObj.state.access_token,
            storeObj.state.selectedCourseObjFromFilter.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.selectedMasterClassModuleList = responseObj.data
              // AK: Hide Spinner after recieving with newly added Lesson list
              _this.$emit('showSpinner', false)
              // _this.showSpinner = false
              _this.$store.state.isLoading = false

              if (this.moduleObj.IsBonusContent) {
                this.prefixString = 'Do you want to add video in the bonus content '
                this.postString = '\'' + this.moduleObj.Title + '\'?'
                this.showConfirmationBox = true
              } else {
                _this.hideCreateLessonOverlay = true
              }
              // AK: Reset Module Obj at last
              this.moduleObj.Index = null
              this.moduleObj.Title = ''
              this.moduleObj.LessonNumberText = ''
              this.moduleObj.ReleaseDate = this.date
              if (this.moduleObj.MasterTopic !== undefined && this.moduleObj.MasterTopic !== null && this.moduleObj.MasterTopic !== '' && this.moduleObj.MasterTopic !== 'null') {
                this.moduleObj.MasterTopic.MasterTopicId = -1
              }
              this.moduleObj.Duration = ''
              this.btnTxt = 'Create Lesson'
              this.moduleObj.IsUnlocked = false
              this.moduleObj.IsBonusContent = false
              this.moduleObj.IsOptional = false
              this.moduleObj.IsPublished = false
              this.config.useCurrent = true
              this.date = dmAdminUtils.getCurrentEst()
            } else {
              // AK: Hide Spinner
              _this.$emit('showSpinner', false)
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            _this.$emit('showSpinner', false)
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'CourseMasterId is NULL hence declined REFRESH LESSON LIST OPERATION'
        )
      }
    },
    setCourseMasterId: function () {
      // console.log(this.$store.state.selectedCourseObjFromFilter.LessonNumbering)
      this.moduleObj.CourseMasterId = this.$store.state.selectedCourseObjFromFilter.CourseMasterId
    },
    setReleaseDate: function () {
      this.moduleObj.ReleaseDate = this.date
    },
    findBy: function (list, value, column) {
      return list.filter(function (item) {
        // return item[column].includes(value)
        // return item[column].indexOf(value) !== -1
        return String(item[column]).toLowerCase().indexOf(String(value).toLowerCase()) !== -1
      })
    }
  },
  computed: {
    getCurrentCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getMasterTopicList: {
      get: function () {
        return this.$store.state.masterTopicList
      }
    },
    tableFilter: {
      get: function () {
        // alert('this.objArr in tableFilter >>>>>> ' + this.objArr)
        if (this.enteredLessonNameInSearch !== null && !this.$store.state.isLessonSwipped) {
          // alert('From Search')
          this.objArr = this.findBy(this.lessonList, this.enteredLessonNameInSearch, 'Title')
        } else if (!this.$store.state.isLessonSwipped) {
          // alert('From Original List')
          this.objArr = this.$store.state.selectedMasterClassModuleList
        } else {
          // alert('From Swipped')
          this.objArr = this.objArr
        }
        return this.objArr
      },
      set: function (newValue) {
        // console.log('this.enteredLessonNameInSearch >>' + this.enteredLessonNameInSearch)
        if (this.enteredLessonNameInSearch !== null && this.enteredLessonNameInSearch !== '') {
          this.showAlertDialog = true
          this.errorMsg = 'Please remove lesson filter to re-order selected lesson.'
          return
        }
        // AK: As soon as user swipped lessons, show confirmation dialog
        this.prefixString = 'Are you sure you want to re-order '
        this.postString = 'selected lesson?'
        this.showConfirmationBox = true
        // AK: Change flag to true
        this.$store.state.isLessonSwipped = true
        // AK: Clear search filter value if written by user
        this.enteredLessonNameInSearch = null
        this.objArr = newValue
        // alert(JSON.stringify(this.objArr))
        // console.log('Re-ordered >>> ' + JSON.stringify(this.objArr))
      }
    },
    lessonList () {
      this.objArr = this.$store.state.selectedMasterClassModuleList
      // alert('lessonList >>>> ' + JSON.stringify(this.objArr))
      return this.objArr
    },
    lessonIndexValue: {
      get: function () {
        return this.moduleObj.Index
      },
      set: function (newValue) {
        if (newValue !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            this.moduleObj.Index = parseInt(newValue)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.moduleObj.Index = null
          }
        } else {
          this.moduleObj.Index = null
        }
      }
    },
    lessonTitleValue: {
      get: function () {
        return this.moduleObj.Title
      },
      set: function (newValue) {
        this.moduleObj.Title = newValue
      }
    },
    lessonNumberTextValue: {
      get: function () {
        return this.moduleObj.LessonNumberText
      },
      set: function (newValue) {
        this.moduleObj.LessonNumberText = newValue
      }
    },
    lessonTopicObjValue: {
      get: function () {
        if (this.moduleObj.MasterTopic !== undefined && this.moduleObj.MasterTopic !== null && this.moduleObj.MasterTopic !== '' && this.moduleObj.MasterTopic !== 'null') {
          return this.moduleObj.MasterTopic.MasterTopicId
        } else {
          return -1
        }
      },
      set: function (newValue) {
        this.moduleObj.MasterTopic.MasterTopicId = newValue
      }
    },
    moduleTypeValue: {
      get: function () {
        return this.moduleObj.ModuleType
      },
      set: function (newValue) {
        this.moduleObj.ModuleType = parseInt(newValue)
      }
    },
    lessonReleaseDateValue: {
      get: function () {
        return this.moduleObj.ReleaseDate
      },
      set: function (newValue) {
        this.moduleObj.ReleaseDate = newValue
      }
    },
    lessonDurationValue: {
      get: function () {
        return this.moduleObj.Duration
      },
      set: function (newValue) {
        this.moduleObj.Duration = newValue
      }
    },
    lessonUnlockedValue: {
      get: function () {
        return this.moduleObj.IsUnlocked
      },
      set: function (newValue) {
        this.moduleObj.IsUnlocked = newValue
      }
    },
    isBonusContentLessonValue: {
      get: function () {
        return this.moduleObj.IsBonusContent
      },
      set: function (newValue) {
        this.btnTxt = 'Create Lesson'
        if (newValue === true) {
          this.btnTxt = 'Create Bonus Content'
          this.moduleObj.IsOptional = false
          this.moduleObj.Index = ''
          this.moduleObj.MasterTopic.MasterTopicId = -1
        }
        this.moduleObj.IsBonusContent = newValue
      }
    },
    isOptionalLessonValue: {
      get: function () {
        return this.moduleObj.IsOptional
      },
      set: function (newValue) {
        if (newValue === true) {
          this.btnTxt = 'Create Lesson'
          this.moduleObj.IsBonusContent = false
        }
        this.moduleObj.IsOptional = newValue
      }
    },
    isPublishedLessonValue: {
      get: function () {
        return this.moduleObj.IsPublished
      },
      set: function (newValue) {
        this.moduleObj.IsPublished = newValue
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
.padding-left-0px {
  padding-left: 0px;
}
.padding-top-7px {
  padding-top: 7px;
}
.padding-bottom-4px {
  padding-bottom: 4px;
}
.font-size-16px {
  font-size: 16px;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-1Perc {
  padding-top: 1%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-3Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}
.margin-top-2Point5Perc{
  margin-top: 2.5%;
}
.padding-left-2Perc{
  padding-left: 2%; 
}
.padding-left-5Perc{
  padding-left: 5%;
}
.border-red {
  border: 1px solid red;
}
</style>


// WEBPACK FOOTER //
// src/components/CreateLesson.vue